import angular from 'angular';

import IdentityComponent from './identity.cmpt';
import IdentitySceneModule from './scene';

export default angular
    .module('application.scene.identity', [
        IdentitySceneModule.name
    ])
    .component(IdentityComponent.selector, IdentityComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity', {
        url: '?redirect',
        redirectTo: 'identity.sign-in',
        template: '<db-a-identity class="block-component"></db-a-identity>'
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/index.js